import React, { useState } from "react";
import { useSelector } from "react-redux";
import CampaignAccordion from "../MetaTravelAdsFormComponents/Campaign/CampaignAccordion.jsx";
import ObjectiveAccordion from "../MetaTravelAdsFormComponents/Objective/ObjectiveAccordion";
import CampaignSettingsAccordion from "../MetaTravelAdsFormComponents/CampaignSettings/CampaignSettingsAccordion";
import { ExpandMore } from "@mui/icons-material";
import RetargetingForm from "../MetaTravelAdsFormComponents/AudiencesForm/RetargetingForm";
import ProspectingForm from "../MetaTravelAdsFormComponents/AudiencesForm/ProspectingForm";
import MetaAudienceForm from "../MetaTravelAdsFormComponents/AudiencesForm/MetaAudienceForm";
import {ReactComponent as IconAIGreen} from 'assets/images/IconAIGreen.svg'
import AdsCreative from "../MetaTravelAdsFormComponents/AdsCreative/AdsCreative";

const MetaTravelAdsCampaignEditor = ({
  expandedPanel,
  setExpandedPanel,
  selectedObjective,
  setSelectedObjective,
  visitedPanels,
  handleNext,
  selectedCountries,
  setSelectedCountries,
  selectedLanguage,
  setSelectedLanguage,
  targetValue,
  setTargetValue,
  biddingStrategy,
  setBiddingStrategy,
  campaignName,
  setCampaignName,
  campaignBudget,
  setCampaignBudget,
  monthlyBudget,
  setMonthlyBudget,
  dailyBudgetCap,
  setDailyBudgetCap,
  currencySymbol,
  campaignId,
  placementDetails,
  setPlacementDetails,
  clickThroughValue,
  setClickThroughValue,
  viewThroughValue,
  setViewThroughValue,
  adsCreativeCards,
  setAdsCreativeCards,
  hotelId,
  ageRange,
  setAgeRange,
  selectedGender,
  setSelectedGender,
  isBookingWindowEnabled,
  setIsBookingWindowEnabled,
  bookingWindowRange,
  setBookingWindowRange,
  rules,
  setRules,
  onSaveSettings,
  onSaveAudience,
  onSaveAdsCreative,
  selectedMetaAudience,
  setSelectedMetaAudience,
  selectedIncludeAudiences,
  setSelectedIncludeAudiences,
  selectedExcludeAudiences,
  setSelectedExcludeAudiences,
  metaAudienceOptions,
  isLoadingMetaAudienceOptions,
  isSharedAudienceEnabled,
  isMultiHotelEnabled,
  selectedHotels,
  setSelectedHotels,
  lockedHotels = [],
}) => {
  const [errors, setErrors] = useState({});
  const [allHotelsDone, setAllHotelsDone] = useState(false);
  const { hotelList = [] } = useSelector((state) => state?.account);
  const selectedHotel = hotelList.find((h) => h.hotel_id === hotelId);
  const handleNextWithValidation = async (currentPanel) => {
        handleNext(currentPanel);
    };

  return (
    <>
      <CampaignAccordion
        expandIcon={<ExpandMore />}
        title={`1. Campaign Settings${selectedHotel ? ` - ${selectedHotel.hotel_name} - ${hotelId}` : ""}`}
        expanded={expandedPanel === "settings"}
        onChange={() => setExpandedPanel("settings")}
        onNext={() => handleNextWithValidation("settings")}
        disabled={!visitedPanels.includes("settings")}
        visited={visitedPanels.includes("settings")}
        onSave={onSaveSettings} // Add Save functionality
        isSaveButton={true} // Enable Save Button
      >
        <CampaignSettingsAccordion
          biddingStrategy={biddingStrategy}
          setBiddingStrategy={setBiddingStrategy}
          campaignName={campaignName}
          setCampaignName={setCampaignName}
          campaignBudget={campaignBudget}
          setCampaignBudget={setCampaignBudget}
          targetValue={targetValue}
          setTargetValue={setTargetValue}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          selectedCountries={selectedCountries}
          setSelectedCountries={setSelectedCountries}
          monthlyBudget={monthlyBudget}
          setMonthlyBudget={setMonthlyBudget}
          errors={errors}
          dailyBudgetCap={dailyBudgetCap}
          setDailyBudgetCap={setDailyBudgetCap}
          currencySymbol={currencySymbol}
          // props placements
          placementDetails={placementDetails}
          setPlacementDetails={setPlacementDetails}
          isEdit
          campaignId={campaignId}
          clickThroughValue={clickThroughValue}
          setClickThroughValue={setClickThroughValue}
          viewThroughValue={viewThroughValue}
          setViewThroughValue={setViewThroughValue}
          selectedHotels={selectedHotels}
          setSelectedHotels={setSelectedHotels}
          isMultiHotelEnabled={isMultiHotelEnabled}
          lockedHotels={lockedHotels}
        />
      </CampaignAccordion>

      <CampaignAccordion
        expandIcon={<ExpandMore />}
        title="2. Audiences"
        expanded={expandedPanel === "audiences"}
        onChange={() => setExpandedPanel("audiences")}
        onNext={() => handleNextWithValidation("audiences")}
        disabled={!visitedPanels.includes("audiences")}
        visited={visitedPanels.includes("audiences")}
        onSave={onSaveAudience} // Add Save functionality
        isSaveButton={true} // Enable Save Button
      >
        <div style={{ marginBottom: "16px", paddingLeft: "40px" }}>
          <ObjectiveAccordion
            selectedObjective={selectedObjective}
            setSelectedObjective={setSelectedObjective}
            isSharedAudienceEnabled={isSharedAudienceEnabled}
          />
          {selectedObjective === "RETARGETING" && (
            <RetargetingForm
              ageRange={ageRange}
              setAgeRange={setAgeRange}
              selectedGender={selectedGender}
              setSelectedGender={setSelectedGender}
              isBookingWindowEnabled={isBookingWindowEnabled}
              setIsBookingWindowEnabled={setIsBookingWindowEnabled}
              bookingWindowRange={bookingWindowRange}
              setBookingWindowRange={setBookingWindowRange}
              rules={rules}
              setRules={setRules}
              errors={errors}
              isEdit
            />
          )}
          {selectedObjective === "PROSPECTING" && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "22px" }}
            >
              <p
                style={{
                  display: "flex",
                  gap: "8px",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#373F41",
                  marginTop: "30px",
                }}
              >
                <IconAIGreen fontSize="26px" />
                <span style={{ maxWidth: "380px" }}>
                  Your Audience setup is creating more opportunities to improve
                  performance with AI. We won't reach people beyond the controls
                  that you set, even with Advantage+ on.
                </span>
              </p>
              <ProspectingForm
                ageRange={ageRange}
                setAgeRange={setAgeRange}
                selectedGender={selectedGender}
                setSelectedGender={setSelectedGender}
                isBookingWindowEnabled={isBookingWindowEnabled}
                setIsBookingWindowEnabled={setIsBookingWindowEnabled}
                bookingWindowRange={bookingWindowRange}
                setBookingWindowRange={setBookingWindowRange}
                rules={rules}
                setRules={setRules}
                errors={{}}
                isEdit
                selectedIncludeAudiences={selectedIncludeAudiences}
                setSelectedIncludeAudiences={setSelectedIncludeAudiences}
                metaAudienceOptions={metaAudienceOptions}
                isLoadingMetaAudienceOptions={isLoadingMetaAudienceOptions}
                isSharedAudienceEnabled={isSharedAudienceEnabled}
              />
            </div>
          )}
          {selectedObjective === "META_AUDIENCE" && isSharedAudienceEnabled && (
            <MetaAudienceForm
              selectedMetaAudience={selectedMetaAudience}
              setSelectedMetaAudience={setSelectedMetaAudience}
              selectedIncludeAudiences={selectedIncludeAudiences}
              setSelectedIncludeAudiences={setSelectedIncludeAudiences}
              selectedExcludeAudiences={selectedExcludeAudiences}
              setSelectedExcludeAudiences={setSelectedExcludeAudiences}
              metaAudienceOptions={metaAudienceOptions}
              isLoadingOptions={isLoadingMetaAudienceOptions}
            />
          )}
        </div>
      </CampaignAccordion>

      <CampaignAccordion
        expandIcon={<ExpandMore />}
        title="3. Ads Creative"
        expanded={expandedPanel === "adsCreative"}
        onChange={() => setExpandedPanel("adsCreative")}
        disabled={!visitedPanels.includes("adsCreative")}
        visited={visitedPanels.includes("adsCreative")}
        onSave={onSaveAdsCreative}
        isSaveButton={true}
        saveButtonLabel="Publish"
        disabledSave={!allHotelsDone}
        noNextButton={true}
      >
        <AdsCreative key={campaignId} hotelId={hotelId} adsCreativeCards={adsCreativeCards} setAdsCreativeCards={setAdsCreativeCards} selectedHotels={selectedHotels} onAllDoneChange={setAllHotelsDone} isMultiHotelEnabled={isMultiHotelEnabled} selectedLanguage={selectedLanguage} />
      </CampaignAccordion>
    </>
  );
};

export default MetaTravelAdsCampaignEditor;
